import { render } from "./Welcome.vue?vue&type=template&id=9ba0d5ec&scoped=true&ts=true"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"

import "./Welcome.vue?vue&type=style&index=0&id=9ba0d5ec&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ba0d5ec"]])

export default __exports__